import { Component, OnInit} from '@angular/core';
import { EChartsOption } from 'echarts';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { AppConfigService } from "src/app/core/services/app-config.service";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  contractsByMonth : number[] = [];
  deniedContractsByMonth : number[] = [];

  barChartOptions: EChartsOption;
  pieChartOptions: EChartsOption;

  companies: any;
  allContracts: any;
  producerId: any;
  defaultImage: string;
  dashboardImageUrl: string;

  constructor(private authServ: AuthenticationService,
              private config: AppConfigService) { }

  ngOnInit(): void {
    this.producerId = this.authServ.getUserId();
    // this.pieChart();
    // this.getContracts();
    this.loadDefaultImage();
  }

  loadDefaultImage(): void{
    this.defaultImage = 'campaña.webp';
    this.dashboardImageUrl = this.config.imagesBaseUrl + this.defaultImage;
  }

  getContracts(){
    this.authServ.getAllContracts(this.producerId).then((res:any)=>{
      console.log(res);
      this.allContracts = res;
      let aprovedContracts = res.filter((x:any)=> x.paid == true);
      let deniedContracts = res.filter((x:any)=> x.active == false);
      let today = new Date();
      for(let i=0; i<12;i++){
        let monthQty = aprovedContracts.filter((x: { createdModified: any; }) => new Date(x.createdModified).getMonth() == i && new Date(x.createdModified).getFullYear() == today.getFullYear()).length;
        console.log(monthQty);
        if(Array.isArray( this.contractsByMonth)){
          this.contractsByMonth.push(monthQty);
        }
      }

      for(let i=0; i<12;i++){
        let monthQty = deniedContracts.filter((x: { createdModified: any; }) => new Date(x.createdModified).getMonth() == i && new Date(x.createdModified).getFullYear() == today.getFullYear()).length;
        console.log(monthQty);
        if(Array.isArray( this.deniedContractsByMonth)){
          this.deniedContractsByMonth.push(monthQty);
        }
      }

      this.authServ.getCompanies().then((res2:any)=>{
        this.companies = res2.map((company: any) => {
          return {value: 0, name: company.name}
        });
        console.log(this.companies);
        for(let i=0; i<this.companies.length; i++){
          let companyQty = res.filter((contract:any)=> contract.insCompany == this.companies[i].name).length;
          this.companies[i].value = companyQty;
        }
        console.log(this.companies);
        this.createCharts();
      })

      console.log(this.contractsByMonth);
      
      
    })
  }

  updatePie(data:any){
    let contracts;
    if(data == "all"){
      contracts = this.allContracts;
    }
    if(data == "approved"){
      contracts = this.allContracts.filter((x:any)=> x.paid == true);
    }
    if(data == "cancelled"){
      contracts = this.allContracts.filter((x:any)=> x.active == false);
    }
    for(let i=0; i<this.companies.length; i++){
      let companyQty = contracts.filter((contract:any)=> contract.insCompany == this.companies[i].name).length;
      this.companies[i].value = companyQty;
    }

    this.createCharts();
  }

  createCharts(){
    this.barChartOptions = {
      color: ['#3398DB','#dc3545'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: [
        {
          type: 'category',
          data: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
        },
      ],
      series: [
        {
          name: 'Aprobados',
          type: 'bar',
          barWidth: '20%',
          data: this.contractsByMonth,
        },
        {
          name: 'Canceladas',
          type: 'bar',
          barWidth: '20%',
          data: this.deniedContractsByMonth,
        },
      ],
    };

    this.pieChartOptions = {
      tooltip: {
        trigger: 'item'
      },
      series: [
        {
          type: 'pie',
          radius: '60%',
          data: this.companies,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
  }

}
